module.exports = __webpack_public_path__ + "static/media/kiwi2.7b4811ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/kiwi2.png
// module id = 54
// module chunks = 0